const SmallCheckIcon = () => {
    return (
        <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 7L5.5 10.5L13.5 2.5" stroke="white" strokeWidth="1.6" strokeLinecap="square" strokeLinejoin="round"/>
        </svg>
    );
}

export default SmallCheckIcon;
